// extracted by mini-css-extract-plugin
export default {"title":"SectionA_title__GPFLN","sectionA":"SectionA_sectionA__6557z"};